var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';
import { toJS, comparer } from 'mobx';
export class AsyncDataSource {
    constructor(operations, idSelector, withCache) {
        Object.defineProperty(this, "idSelector", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "operations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "withCache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cached", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cancelation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.operations = operations;
        this.idSelector = idSelector;
        this.withCache = withCache;
    }
    getData(state) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.cancelation) {
                this.cancelation.cancel();
            }
            if (this.withCache && this.cached && comparer.structural(this.cached.state, state)) {
                return cloneDeep(this.cached.result);
            }
            this.cancelation = axios.CancelToken.source();
            const result = toJS(yield this.operations.get(state, this.cancelation.token));
            this.cancelation = undefined;
            this.cached = { state, result };
            return cloneDeep(result);
        });
    }
    addData(row, index) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.operations.add) {
                throw 'missing add function in the operations';
            }
            const result = yield this.operations.add(row, index);
            this.cached = undefined;
            return result;
        });
    }
    updateData(id, changes) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.operations.update) {
                throw 'missing update function in the operations';
            }
            yield this.operations.update(id, changes);
            this.cached = undefined;
        });
    }
    removeData(id) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.operations.remove) {
                throw 'missing remove function in the operations';
            }
            const result = yield this.operations.remove(id);
            this.cached = undefined;
            return result;
        });
    }
}
//# sourceMappingURL=async-data-source.js.map